import React, { useEffect } from "react";
import axios from "axios";
import "./App.css";

function App() {
  useEffect(() => {
    axios.post("https://piacit.hu/web-visitors", {});
  }, []);

  const handleButtonClick = (event) => {
    event.stopPropagation(); // Megakadályozza az esemény buborékolását
    const targetId = event.target.id;
    switch (targetId) {
      case "downloadAndroid":
        console.log("Android press")
        axios.post("https://piacit.hu/web-android-button", {});
        window.open("https://play.google.com/store/apps/details?id=hu.piacit", "_blank");
        break;
      case "downloadIos":
        console.log("iOS press")
        axios.post("https://piacit.hu/web-ios-button", {});
        window.open("https://apps.apple.com/us/app/piacit/id6742785558", "_blank");
        break;
      case "facebook":
        console.log("facebook press")
        axios.post("https://piacit.hu/web-facebook-button", {});
        window.open("https://www.facebook.com/groups/2018969698584951", "_blank");
        break;
      case "youtube":
        console.log("youtube press")
        axios.post("https://piacit.hu/web-youtube-button", {});
        window.open("https://youtube.com/playlist?list=PLY2dU7v99zyMI4D9zpicFmlyQ1hhrCaZF&si=xfvePj9sREjlMclk", "_blank");
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="container">
        <div className="header">
          <div className="flex-column">
            <p className="logo">piacIT</p>
            <p className="cel-p blue" style={{ marginTop:"-30px"}}>mobil alkalmazás</p>
          </div>

          <p className="slogan">Portékád ne csak a rokonok között<br></br> legyen sláger!</p>
          {/*<p className="cel-p-green">Angol és német nyelven is!</p>*/}
        </div>
        <div className="app">
          <div className="flex-column">
            <img className="main-screen"
                src="./images/main-screen.png"
                alt="main-screen"
            />
        </div>
        <div className="flex-column">
          <p className="toltsd-le" >Töltsd le és regisztrálj!</p>
          <p className="instructions">Add meg árusítási helyedet és tegyél fel pár terméket!<br></br> Pár perc munka és már ott is vagy a környék mobiljain!</p>
          <div id="downloadAndroid" className="button-container" onClick={handleButtonClick}>
            <img
                src="./images/google-store.png"
                alt="Android ikon"
                className="btn-store"
              />
          </div>
          <div id="downloadIos" className="button-container" onClick={handleButtonClick}>
            <img
                src="./images/app-store.png"
                alt="Android ikon"
                className="btn-store"
              />
          </div>
        </div>


        </div>
        <div className="flex-column" style={{ marginTop: "80px" }}>
          <p className="subtitle">Több mint 30 térképes jelölő közül válogathatsz</p>
          <img
              className="map-image"
              src="./images/map.png"
              alt="main-screen"
            />
        </div>
        <div className="flex-column" style={{ marginTop: "50px" }}>
          <p className="subtitle">Hozd közelebb a vásárlókat!</p>
          <p style={{ width: "80%", margin: "0 auto", textAlign: "center" }}>
            <br></br>Új virtuális piactér, ahol a terméked nem a polcon ül, hanem repül a vásárlók felé!<br></br>
          </p>
        </div>
        <div className="flex-column" style={{ marginTop: "50px" }}>
          <p className="subtitle">Érjen sokkal többet a munkád!</p>
          <p style={{ width: "80%", margin: "0 auto", textAlign: "center" }}>
            <br></br>Az app célja, hogy a vásárlók megtalálják termékeidet a közelükben<br></br>és TŐLED is vásároljanak!<br></br>
          </p>
        </div>

        <div className="flex-column" style={{ marginTop: "50px" }}>
          <p className="subtitle">Facebook csoportunk</p>
          <p style={{ width: "80%", margin: "0 auto", textAlign: "center" }}>
            <br></br>Kommunikációs csatorna a közösségünk tagjainak, infók az app fejlesztéseiről és használatáról, kérdések/válaszok<br></br>
          </p>
          <div id="facebook" className="button-container" onClick={handleButtonClick} style={{ marginTop: "30px" }}>
            <img
              src="./images/facebook.png"
              alt="Facebook ikon"
              className="btn-facebook"
            />
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
          <div className="video-wrapper" style={{ borderRadius:"10px" }}>
            <iframe
              src="https://www.youtube.com/embed/JPgMHIoi5-s?autoplay=0&mute=1&rel=0&playsinline=1"
              title="piacIT bemutató videó"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>



        {/*
        <HighlightsCarousel />
        <div className="buttons">
          <div id="youtube" className="button-container" onClick={handleButtonClick}>
            <img
              src="./images/youtube.png"
              alt="YouTube ikon"
              className="btn"
            />
          </div>
        </div>
        */}

        <div style={{ position: "relative", marginTop: "60px", top: "0", left: "0", width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }} >
          <div style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", maxWidth: "600px", width: "80%", position: "relative" }}  onClick={(e) => e.stopPropagation()} >
            <h3 style={{ textAlign: "center" }}>Miért érdemes csatlakozni a közösségünkhöz, mint őstermelő, kistermelő vagy kézműves?</h3>
            <p>
              A vásárlók egyre inkább a helyi, minőségi termékeket keresik, és mi itt vagyunk, hogy segítsünk Téged abban, hogy a lehető legjobb módon elérd őket. Gondolj arra, hogy munkád sokkal többet érhet, ha közvetlen kapcsolatba lépsz a vásárlókkal, anélkül, hogy a nagykereskedők közvetítőként beleszólnának áraid alakulásába.
            </p>
            <p>
              <strong>Közösségünk fő célja</strong>, hogy a vásárlók könnyen rád találjanak, és felfedezzék mindazt, amit kínálsz. Egy olyan platformot hoztunk létre, amely nemcsak segít kiemelkedni a termelők tömegéből, hanem <strong>lehetőséget is ad arra, hogy szerepelj a térképen</strong>, így a vásárlók könnyen rátalálnak termékeidre, bárhol is vagy.
            </p>
            <p>
              Tartsd kézben az árképzést: töltsd fel termékeidet árakkal és fotókkal, <strong>döntsd el TE, hogy mennyit ér a munkád!</strong>
            </p>
            <p>
              Fontos, hogy <strong>személyes kapcsolatot építhess ki a vásárlókkal</strong>. Profilod kitöltésével bemutathatod gazdaságodat, és megoszthatod történetedet, hogy vásárlóid megismerhessenek. Ezen kívül nemcsak a helyi vásárlók, hanem a külföldi érdeklődők is elérhetnek, így a határokon túlról érkezők is találkozhatnak a termékeiddel.
            </p>
            <p>
              Ha nem vagy biztos benne, hogyan kezdj neki, ne aggódj! Videós bemutatóink gyors segítséget nyújtanak, hogy könnyedén eligazodj a platform használatában. Ha bármilyen kérdésed lenne, <strong>támogató Facebook csoportunkban segítünk</strong>.
            </p>
            <p>
              Ne hagyd ki a lehetőséget, hogy részesévé válj egy olyan közösségnek, ahol a helyi termelők és kézművesek összeállnak, hogy közösen növeljék erejüket. <br></br><br></br><strong>Csatlakozz most, és alakítsuk együtt a jövőt!</strong>
            </p>
          </div>
        </div>

        {/*<p className="cel-p green">
            <br></br>*Legalább 1000, termékkel rendelkező őstermelő/kézműves szükséges a vásárlók marketingeléséhez! 
            <br></br>
        </p>*/}

        <p className="cel-p blue">
            <br></br>Fejlesztő: Bencsik János 
            <br></br>Tel.: +36 70 614 1080
            <br></br>E-mail: hello @ piacit.hu
            <br></br>
            <br></br>Utolsó frissítés: 2025 július 8.
        </p>
        <p className="cel-p green">
            <br></br>
            <br></br>
        </p>
      </div>

    </>
  );
}

export default App;
